import React, {Fragment, useState} from 'react'
import {Link} from 'react-router-dom'
import { Menu } from 'antd';
import { useMediaQuery } from 'react-responsive'
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';

const { SubMenu } = Menu;


export default function Header(props) {
    const [collapsed, setCollapsed] = useState(true);
    const [currentUrl, setCurrentUrl] = useState(window.location.pathname);

    const handleClick = (e) => {
        setCurrentUrl(window.location.pathname);
        setCollapsed(true);
    }

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    /*const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
    })*/

    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })

    const menuItems = (
        <Fragment>
            <Menu.Item key="/proofreading-works-of-fiction">
                <Link to="/proofreading-works-of-fiction"><span>Proofreading Works of Fiction</span></Link>
            </Menu.Item>
            <Menu.Item key="/proofreading-thesis-dissertation-essay">
                <Link to="/proofreading-thesis-dissertation-essay"><span>Proofreading of Thesis/ Dissertation/ Essay</span></Link>
            </Menu.Item>
            <Menu.Item key="/proof-listen-audiobooks">
                <Link to="/proof-listen-audiobooks"><span>Proof Listen to Audiobooks</span></Link>
            </Menu.Item>
            <Menu.Item key="/audiobook-narration-for-picture-books">
                <Link to="/audiobook-narration-for-picture-books"><span>Audiobook Narration for Picture Books</span></Link>
            </Menu.Item>
            <Menu.Item key="/writers-dilemma">
                <Link to="/writers-dilemma"><span>Writer's Dilemma</span></Link>
            </Menu.Item>
            <Menu.Item key="/writing-your-blurb">
                <Link to="/writing-your-blurb"><span>Writing your Blurb</span></Link>
            </Menu.Item>
            <Menu.Item key="/write-back-cover-review">
                <Link to="/write-back-cover-review"><span>Write a Back-cover review</span></Link>
            </Menu.Item>
            {/*
            <Menu.Item key="/terms-and-conditions" style={{float: 'right'}}>
                <Link to="/terms-and-conditions"><span>Terms & Conditions</span></Link>
            </Menu.Item>
            <Menu.Item key="/about" style={{float: 'right'}}>
                <Link to="/about"><span>About Me</span></Link>
            </Menu.Item>
            */}
        </Fragment>
    )

    return (
        <Fragment>
            <Menu onClick={handleClick} selectedKeys={[currentUrl]} openKeys={collapsed ? [''] : ['menu']} mode={isPortrait ? 'inline' : 'horizontal'}>
                <Menu.Item key="homepage">
                    <Link to="/"><img src={'/logo200.png'} alt="logo" className='logo' /></Link>
                </Menu.Item>
                {<SubMenu onTitleClick={toggleCollapsed} key='menu' icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} title='Services'>{menuItems}</SubMenu>}
                <Menu.Item key="/terms-and-conditions" style={{float: 'right'}}>
                    <Link to="/terms-and-conditions"><span>Terms & Conditions</span></Link>
                </Menu.Item>
                <Menu.Item key="/stripe" style={{float: 'right'}}>
                    <a href='https://climate.stripe.com/fTPpG8' target="_blank"><span>Carbon Footprint Reduction</span></a>
                </Menu.Item>
                <Menu.Item key="/contact" style={{float: 'right'}}>
                    <Link to="/contact"><span>Contact</span></Link>
                </Menu.Item>
                <Menu.Item key="/about" style={{float: 'right'}}>
                    <Link to="/about"><span>About Me</span></Link>
                </Menu.Item>

                {/*!isDesktopOrLaptop && <SubMenu onTitleClick={toggleCollapsed} key='menu' icon={<>{collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}  Services</>} title=''>{menuItems}</SubMenu>}
                {isDesktopOrLaptop && menuItems*/}
            </Menu>
        </Fragment>

        )
}
